module.exports = __webpack_public_path__ + "img/encryption.a82679d4.png";